import Vuex from 'vuex'




export const store =  new Vuex.Store({
	state: {
		rightView: 'org-single-quotes',
		prop1: '',
		prop2: '',
		prop3: [],

		orgDetails: [],
		orgDetailsComp: '0',

		orgContacts: [],
		orgContactsComp: '0',

		orgQuotes: [],
		orgQuotesComp: '0',

		userLatestOrgs: [],
		userLatestOrgsComp: '0',

		inviteArray: [],
		inviteComp: '0',



	},

	mutations: {
		setRightView(state, payload) { state.rightView = payload.name; state.prop1 = payload.prop1; state.prop2 = payload.prop2; state.prop3 = payload.prop3},

		setOrgDetails(state, payload) { state.orgDetails = payload.info; state.orgDetailsComp = payload.info1; },
		setOrgDetailsComp(state, payload) { state.orgDetailsComp = payload.info1; },

		setOrgContacts(state, payload) { state.orgContacts = payload.info; state.orgContactsComp = payload.info1; },
		setOrgContactsComp(state, payload) { state.orgContactsComp = payload.info1; },

		setOrgQuotes(state, payload) { state.orgQuotes = payload.info; state.orgQuotesComp = payload.info1; },
		setOrgQuotesComp(state, payload) { state.orgQuotesComp = payload.info1; },
		
  	},

	actions: {
		getRightView(context, payload) { context.commit("setRightView", { name: payload.name, prop1: payload.prop1, prop2: payload.prop2, prop3: payload.prop3, })  },

		getOrgDetails(context, payload) {
			context.commit("setOrgDetailsComp", { info1: '0' }) 
			axios.get('/utility/user/org/getorgdetails/' + payload.org )
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setOrgDetails", { info: b, info1: '1' }) 
	          	});
		},

		getOrgContacts(context, payload) {
			context.commit("setOrgContactsComp", { info1: '0' }) 
			axios.get('/utility/user/contact/getallcontactsbyorg/' + payload.org )
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setOrgContacts", { info: b, info1: '1' }) 
	          	});
		},

		getOrgQuotes(context, payload) {
			context.commit("setOrgQuotesComp", { info1: '0' }) 
			axios.get('/utility/user/quote/getquotesbyorg/' + payload.org )
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setOrgQuotes", { info: b, info1: '1' }) 
	          	});
		},
		
	}

})